export const INCOMPLETE_ADDRESS_FIELD_KEYS = [
  "firstName",
  "lastName",
  "company",
  "street",
  "postalCode",
  "city",
  "country",
  "phone",
];

export const isFieldMissing = (value) => !value || !String(value).trim();

export const getCompanyName = (address, profile) =>
  address?.company_name || profile?.company;

export const getMissingAddressFieldKeys = (address, profile) => {
  if (!address) return [...INCOMPLETE_ADDRESS_FIELD_KEYS];

  const missingFields = [];

  if (isFieldMissing(address.first_name)) missingFields.push("firstName");
  if (isFieldMissing(address.last_name)) missingFields.push("lastName");
  if (isFieldMissing(getCompanyName(address, profile))) missingFields.push("company");
  if (isFieldMissing(address.street)) missingFields.push("street");
  if (isFieldMissing(address.postal_code)) missingFields.push("postalCode");
  if (isFieldMissing(address.city)) missingFields.push("city");
  if (isFieldMissing(address.country)) missingFields.push("country");
  if (isFieldMissing(address.phone)) missingFields.push("phone");

  return missingFields;
};

export const isAddressIncomplete = (address, profile) =>
  getMissingAddressFieldKeys(address, profile).length > 0;

export const getIncompleteAddressMessages = (address, profile, t) =>
  getMissingAddressFieldKeys(address, profile).map((fieldKey) =>
    t(`shop.incompleteAddress.${fieldKey}`)
  );

export const getIncompleteAddressMessage = (address, profile, t) =>
  getIncompleteAddressMessages(address, profile, t).join(" ");
